import { Anchor, Badge, Card, Flex, Skeleton, Stack, Text, useMatches } from "@mantine/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import classes from "./AuctionCard.module.css";

import { TextSerif } from "@/components/elements";
import { Auction } from "@/types/auctions";
import { formatDate } from "@/utils/formatDate";

export type AuctionCardProps = {
  auction?: Auction;
  onClick?: () => void;
  to?: string;
};

export const AuctionCard: FC<AuctionCardProps> = ({ auction, onClick, to }) => {
  const { t } = useTranslation();
  const isMobile = useMatches({ base: true, md: false });
  const height = isMobile ? 150 : 185;

  return (
    <Card
      h={height}
      className={auction?.id ? classes.card : undefined}
      onClick={auction && auction?.num_cars > 0 ? onClick : undefined}
    >
      <Skeleton visible={!auction} h="100%">
        <Stack justify="space-between" gap={0} h="100%" p={isMobile ? "sm" : "md"}>
          <Flex justify="space-between" align="center">
            <TextSerif size="xs" style={{ flexShrink: 0 }}>
              {formatDate(auction?.start_date)}
            </TextSerif>

            {auction?.place && (
              <Badge variant="light-gray" style={{ maxWidth: "65%", overflow: "hidden" }}>
                <Text component="span" fz="xs" truncate fw={600}>
                  {auction?.place}
                </Text>
              </Badge>
            )}
          </Flex>
          <Stack gap="md" pt="md">
            {to && auction && auction.num_cars > 0 ? (
              <Anchor
                component={Link}
                onClick={(evt) => evt.stopPropagation()}
                to={to}
                size="lg"
                className={classes.clamp2}
                title={auction?.name}
              >
                {auction?.name}
              </Anchor>
            ) : (
              <Text size="lg" ta="left" title={auction?.name} className={classes.clamp2}>
                {auction?.name}
              </Text>
            )}
            {auction?.num_cars === 0 ? (
              <Badge variant="transparent" px={0} py="md" c="dimmed">
                {t("common.dataAvailableSoon")}
              </Badge>
            ) : (
              <Badge variant="light" p="md">
                {t("components.Auctions.cars_on_sale", { value: auction?.num_cars || 0 })}
              </Badge>
            )}
          </Stack>
        </Stack>
      </Skeleton>
    </Card>
  );
};
